import {
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from '@mui/material';
import { Subject } from '../types/subject';

interface SubjectSelectorProps {
  subjects: Subject[];
  selectedSubjectId: string;
  onSelectedSubjectIdChange: (subjectId: string) => void;
  showUniversal?: boolean;
}

const SubjectSelector: React.FC<SubjectSelectorProps> = ({
  subjects,
  selectedSubjectId,
  onSelectedSubjectIdChange,
  showUniversal = false,
}) => (
  <ToggleButtonGroup
    value={selectedSubjectId}
    exclusive
    onChange={(_, subjectId) => {
      if (subjectId === null) return;
      onSelectedSubjectIdChange(subjectId);
    }}
    size="small"
    sx={{ display: 'flex', my: 2, overflowX: 'auto' }}
  >
    {showUniversal && (
      <ToggleButton value="">
        <Typography noWrap>Univerzální</Typography>
      </ToggleButton>
    )}
    {subjects.map((subject) => (
      <Tooltip key={subject.id} title={subject.name} arrow>
        <ToggleButton value={subject.id!} size="medium" sx={{ minWidth: 70 }}>
          <Typography>{subject.id!.toString()}</Typography>
        </ToggleButton>
      </Tooltip>
    ))}
  </ToggleButtonGroup>
);

export default SubjectSelector;
